import { FormControl, FormHelperText } from '@mui/material';
import { type Control, Controller } from 'react-hook-form';

import { RaLabel } from '@modules/_shared/components/form/RaLabel';
import { PhoneInput } from '@modules/_shared/components/PhoneInput';
import { useLocale } from '@shared/hooks/locale';

export type RaPhoneNumberProps = {
  control: Control<any>;
  name: string;
  label: string;
  required?: boolean;
};

export const RaPhoneNumber: React.FC<RaPhoneNumberProps> = ({
  control,
  name,
  label,
  required = false,
}) => {
  const { t } = useLocale();
  const rules = {
    required: required ? t('This field is required') : undefined,
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <FormControl fullWidth error={!!error}>
          <RaLabel label={label} required={required} />
          <PhoneInput
            {...field}
            size="small"
            variant="outlined"
            slotProps={{
              input: {
                sx: { background: 'var(--mui-palette-background-paper)' },
              },
            }}
            fullWidth
          />
          {error?.message && <FormHelperText>{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};
